import { ClientError } from '../errors';
import fetchTokenStrategy from '../fetch-token-strategy';

export const downloadFileWithCode = async (
  url: string,
  params: { code: string; versionId?: string },
): Promise<void> => {
  const token = await fetchTokenStrategy();
  const headers = {
    Authorization: `Bearer ${token}`,
  } as Record<string, string>;
  const impersonatedUserID = localStorage.getItem('impersonatedUserID');

  if (impersonatedUserID) {
    headers['X-Impersonated-User-ID'] = impersonatedUserID;
  }

  const requestUrl = new URL(url);
  requestUrl.searchParams.set('code', params.code);
  if (params.versionId) {
    requestUrl.searchParams.set('version_id', params.versionId);
  }

  const response = await fetch(requestUrl.toString(), {
    method: 'POST',
    headers: new Headers(headers),
  });

  if (!response.ok) {
    throw new ClientError('Incorrect code. Check your email and try again.');
  }

  const { download_url: downloadUrl } = (await response.json()) as { download_url?: string };

  if (!downloadUrl) {
    throw new ClientError('Incorrect code. Check your email and try again.');
  }

  window.location.assign(downloadUrl);
};
